module.exports = __webpack_public_path__ + "static/img/wangxingxing.1b46a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/wangxingxing.png
// module id = 1QAO
// module chunks = 0